import { refreshTokenWrapper } from "api/axiosClient";
import { io } from "socket.io-client";
import { getAccessToken, getRefreshToken } from "utils/cookies";
import { localLog } from "utils/functions/common";
import { PATH_ROOT, SOCKET_URL } from "../../constants/api";

// Socket constant
var socket = null;

// Destroy socket if one already exists
if (socket) {
  socket.destroy();
  socket = null;
}
var token = getAccessToken()
socket = io.connect(SOCKET_URL,
  {
    path: PATH_ROOT + '/socket.io',
    query: "type=notification",
    auth: {
      token: token,
    },
  }
).on('expired-authentication', async () => {
  const newToken = await refreshTokenWrapper(getRefreshToken(), false)
  socket.emit('re-authentication', newToken)
});

// function retryConnection({ changed }) {
//   for (const { name, value } of changed) {
//     if (name == COOKIES_TOKEN_KEY && !token) {
//       token = getAccessToken()
//       if (token) {
//         socket.disconnect().connect(SOCKET_URL,
//           {
//             query: "type=notification",
//             auth: {
//               token: token,
//             },
//           })
//         window.cookieStore.removeEventListener('change', retryConnection)
//       }
//     }
//   }
// }

// window.cookieStore.addEventListener('change', retryConnection);

localLog("info socket", token, socket)
// socket.emit("connection");

export default socket;